module.exports = __webpack_public_path__ + "static/wave-grid-90b5d18f19e1e6ce7fad6030298c0f9c.svg";